<template>
  <v-card class="rounded-card body-2" raised>
    <v-sheet
      class="gradient"
    >
      <v-container fill-height container--fluid pl-4 pa-2>
        <v-layout fill-height>
          <v-flex xs12 align-end flexbox>
            <div class="text-h6 white--text font-weight-light">Next Meeting: <span class="font-weight-black">{{meetingDate | formatDateDayOfWeek}}</span>, {{meetingDate | formatDateHours}}</div>
            <div class="text-body-1 white--text">
              <strong>Where: </strong>
			  	<span v-if="location.length>0"><a class="body-1 white--text" :href="'http://maps.google.com/maps?q=' + location" target="_new">{{location}}</a><br/></span>
                <span v-if="virtual_location.substr(0,4)=='http'"> <a class="body-1 white--text" :href="meeting_url">Click to join Zoom online meeting</a>&nbsp;</span>
                <v-btn small color="info" href="#/info/agenda">Agenda &amp; Directions</v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-sheet>
    <v-card-title class="text-break">
      <div>
        <a :href="'#/meeting/' + meetingID">
          <img
            class="floatleft elevation-10"
            :src="image"
            contain
          />
        </a>
          <div class="text-subtitle-2 font-weight-black">{{title}}</div>
          <a class="text-subtitle-2" :href="'#/meeting/' + meetingID">{{speaker}}</a>
          <div class="text-body-2">{{enticement}}</div>
          <a class="text-caption" :href="'#/meeting/' + meetingID">More information about the program</a>
      </div>
    </v-card-title>
    <v-card-text>
      <DropUpload
        uploadWhere="projectionist"
        @uploadComplete='refreshLogin'
        :transparent=true
        :clickable=false
        :maxFiles=2
        class="grey lighten-4"
      >
        <v-flex xs12 class="gradient lighten-2 pa-1" >
          <span class="text-subtitle-2 white--text">{{ meetingDate | formatDateMonth }}'s Member Share &amp; Peer Feedback Topic: </span> <span class="text-subtitle-2 white--text font-weight-black">{{ membershareTitle }}</span>
        </v-flex>
        <div class="text-body-2 black--text" v-html="membershareDescription"/>
        <router-link to="/membershare">
          <v-btn small rounded color="info">
            Upload Member Share
            <v-icon right dark>cloud_upload</v-icon>
          </v-btn>
        </router-link>
        <v-chip small color="green" create_new_folder v-if="$store.state.loggedIn && numMemberShareImages > 0">
          You have uploaded {{ numMemberShareImages }} {{ numImagesText }} to member share &amp; peer feedback
        </v-chip>
      </DropUpload>
    </v-card-text>
  </v-card>
</template>

<script>
import DropUpload from '@/components/DropUpload'
import { TokenService } from '@/services/storage.service'

export default {
  components: {
    DropUpload
  },
  props: {
    speaker: {
      type: String,
      default: ''
    },
    enticement: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: ''
    },
    meetingDate: {
      type: String,
      default: ''
    },
    meetingID: {
      type: Number,
      default: 0
    },
    meeting_url: {
      type: String,
      default: ''
    },
    virtual_location: {
      type: String,
      default: ''
    },
	location: {
		type: String,
		default: ''
	},
    membershareTitle: {
      type: String,
      default: ''
    },
    membershareDescription: {
      type: String,
      default: ''
    }
  },
  computed: {
    numMemberShareImages () {
      return this.$store.state.memberInfo.memberShareImages.length
    },
    website () {
      return process.env.VUE_APP_WEBSITE
    },
    numImagesText () {
      if (this.$store.state.memberInfo.memberShareImages.length === 1) {
        return 'image'
      } else {
        return 'images'
      }
    }
  },
  methods: {
    refreshLogin () {
      TokenService.refreshLogin()
    }
  }
}
</script>

<style scoped>
img.floatleft { 
   margin: 5px 7px 7px 5px;
   float: left;
}
.gradient {
  background: linear-gradient(180deg, #555555 0%,#555555 100%);
}
</style>
